import { z } from 'zod';
import { ROLES } from '../enums';
import { emailSchema, idSchema, passwordSchema, phoneSchema } from './common';
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Mot de passe requis.'),
});
export const registerSchema = z
    .object({
    email: emailSchema,
    password: passwordSchema,
    passwordConfirmation: z.string(),
    firstName: z.string().trim().min(2, 'Prenom requis.').max(100),
    lastName: z.string().trim().min(2, 'Nom requis.').max(100),
    phone: phoneSchema.optional(),
    /**
     * RG-04 : jeton remis a l'issue d'une reservation faite sans compte. Sa presence
     * declenche la conversion du compte GUEST au lieu de la creation d'un compte neuf.
     */
    guestClaimToken: z.string().uuid().optional(),
    acceptTerms: z.literal(true, {
        errorMap: () => ({ message: "Vous devez accepter les conditions generales d'utilisation." }),
    }),
})
    .refine((data) => data.password === data.passwordConfirmation, {
    message: 'Les mots de passe ne correspondent pas.',
    path: ['passwordConfirmation'],
});
export const forgotPasswordSchema = z.object({ email: emailSchema });
export const resetPasswordSchema = z
    .object({
    token: z.string().min(20, 'Jeton invalide.'),
    password: passwordSchema,
    passwordConfirmation: z.string(),
})
    .refine((data) => data.password === data.passwordConfirmation, {
    message: 'Les mots de passe ne correspondent pas.',
    path: ['passwordConfirmation'],
});
export const changePasswordSchema = z
    .object({
    currentPassword: z.string().min(1, 'Mot de passe actuel requis.'),
    password: passwordSchema,
    passwordConfirmation: z.string(),
})
    .refine((data) => data.password === data.passwordConfirmation, {
    message: 'Les mots de passe ne correspondent pas.',
    path: ['passwordConfirmation'],
});
/** Utilisateur authentifie tel que renvoye par `GET /auth/me`. */
export const authenticatedUserSchema = z.object({
    id: idSchema,
    email: z.string().email(),
    firstName: z.string(),
    lastName: z.string(),
    phone: z.string().nullable(),
    role: z.enum(ROLES),
    isGuest: z.boolean(),
    isActive: z.boolean(),
    createdAt: z.string(),
});
/**
 * Le jeton d'acces transite par cookie httpOnly ; il n'apparait jamais dans le corps
 * de la reponse. Seule la date d'expiration est exposee, pour permettre au front de
 * declencher un rafraichissement anticipe.
 */
export const authSessionSchema = z.object({
    user: authenticatedUserSchema,
    accessTokenExpiresAt: z.string(),
});
//# sourceMappingURL=auth.js.map